import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/components/Button';
import Stream from 'flarum/utils/Stream';

import MapModule from '../MapModule';
import UserSubmitModal from './UserSubmitModal';
import InfoSubmitModal from './InfoSubmitModal';

export default class LocationSelectModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.wrapData = this.attrs.wrapData;
    this.editMode = this.attrs.editMode || false;
    this.viewType = this.wrapData.viewType;
    this.returnModal = "";

    if(this.wrapData.returnModal==="UserSubmitModal"){
      this.returnModal = UserSubmitModal;
    }else if(this.wrapData.returnModal==="InfoSubmitModal"){
      this.returnModal = InfoSubmitModal;
    }

    this.mapModule = null;
    this.wrapData.initType = "resume";

    const option_zcwz = this.wrapData.option_zcwz();
    this.clickedLocation = {position:option_zcwz.position,name:option_zcwz.name,province:option_zcwz.province,city:option_zcwz.city};
  }

  className() {
    return 'Modal--large';
  }

  title() {
    return app.translator.trans('ziven-u2di.forum.option-zcwz-select-location');
  }

  onremove(){
    const _this = this;
    setTimeout(function(){
      _this.locationSelectCancelled();
    },100);
  }

  content() {
    const _this = this;
    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    return (
      <div className="locationSelectContainer">
        <div className="locationSelectInfoContainer">
          <div style={this.clickedLocation.position===null?"display:none":""} className="locationSelectInfo">
            <div>{this.clickedLocation.name}</div>

            {this.viewType!=="read" && (
              <div>
                <div style="padding-top: 10px;">
                  {Button.component({
                    style:"min-width:66px;",
                    className: 'Button Button--primary',
                    onclick: (e) => {
                      this.wrapData.option_zcwz = Stream(this.clickedLocation);
                      this.hide();
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.confirm')
                  )}&nbsp;
                  {Button.component({
                    style:"min-width:66px;",
                    className: 'Button',
                    onclick: (e) => {
                      this.hide();
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.cancel')
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="locationSelectMapContainer">
          <MapModule 
            mapModuleCallback = {(mapModule) => {
                _this.mapModule = mapModule;
                _this.addSelectedLocation();
              }
            } 
            mapClassName = "userSubmissionMapContainer" 
            mapModuleID = "userSubmissionMap" 
            mapClickEventListener = {(e) => {
                _this.clickedLocation.position = e;
                _this.clickedLocation.name = null;
                _this.clickedLocation.province = null;
                _this.clickedLocation.city = null;
              }
            } 
            mapGeocoderEventListener = {(e) => {
                const regeocode = e.regeocode;

                if(regeocode){
                  const formattedAddress = regeocode.formattedAddress;
                  const addressComponent = regeocode.addressComponent;
                  _this.clickedLocation.name = formattedAddress;
                  _this.clickedLocation.province = addressComponent.province;
                  _this.clickedLocation.city = addressComponent.city===""?addressComponent.province:addressComponent.city;
                  m.redraw();

                  _this.mapModule.emit('mapAddMarker',{
                      params : {
                        lng: _this.clickedLocation.position.lng,
                        lat: _this.clickedLocation.position.lat,
                        title: _this.clickedLocation.name,
                        clearAllMarker: true,
                        centerMap: true,
                        showInfo: false,
                      },
                  });
                }
              }
            }
          />
        </div>
      </div>
    );
  }

  addSelectedLocation(){
    const position = this.clickedLocation.position;
    const name = this.clickedLocation.name;

    if(position!==null){
      this.mapModule.emit('mapAddMarker',{
        params : {
          lng: position.lng,
          lat: position.lat,
          title: name,
          clearAllMarker: true,
          centerMap: true,
          showInfo: false,
        },
      });
    }
  }

  locationSelectConfirmed(){
    const wrapData = this.wrapData;
    const editMode = this.editMode;
    app.modal.show(this.returnModal,{wrapData,editMode});
  }

  locationSelectCancelled(){
    const wrapData = this.wrapData;
    const editMode = this.editMode;
    app.modal.show(this.returnModal,{wrapData,editMode});
  }

}
